import { Button } from '@/components/ui/button'
import { ArrowDown } from 'lucide-solid'
import { Show } from 'solid-js'
import { useService } from 'solid-services'
import { Box, Flex } from 'styled-system/jsx'
import { useChannel, useUi } from '../../state'
import Notifications from './Notifications'

const MessageActions = (props: { scrollToBottom: () => void }) => {
  // 🚨 Extract missedMessagesCount
  const { notAtBottom, missedMessagesCount } = useService(useChannel)()

  return (
    <Flex
      position="absolute"
      justifyContent="space-between"
      top={1}
      px={6}
      py={4}
      width="100%"
      zIndex={1}
    >
      <Box>
        <Notifications />
      </Box>

      <Box>
        {/* 🚨 Force the button to show if there are missed messages, even if they hit the bottom of their local history chunk */}
        <Show when={notAtBottom() || missedMessagesCount() > 0}>
          <Button
            colorPalette="fg"
            size="xs"
            variant="subtle"
            position='relative'
            onClick={props.scrollToBottom}
          >
            Latest

            {/* 🚨 Red Notification Dot */}
            <Show when={missedMessagesCount() > 0}>
              <Box
                position='absolute'
                top={-1}
                right={-1}
                as="span"
                bg="red.500"
                color="white"
                borderRadius="full"
                minWidth="16px"
                height="16px"
                display="flex"
                alignItems="center"
                justifyContent="center"
                fontSize="10px"
                fontWeight="bold"
              >
                {missedMessagesCount()}
              </Box>
            </Show>

            <ArrowDown />
          </Button>
        </Show>
      </Box>
    </Flex>
  )
}

export default MessageActions
